// import { createApp } from 'vue';
// import App from './App.vue';
// import router from './router';
// import store from './store';
//
// createApp(App).use(store).use(router).mount('#app');

import 'babel-polyfill';

import { createApp } from 'vue';

import toast from '@/plugins/vue-toast-notification';
import i18n from '@/plugins/i18n';
import VeeValidatePlugin from '@/plugins/vee-validate';
import store from '@/store';
import router from '@/router';
import helperMixin from '@/mixins/helper';
import { VTooltip } from 'floating-vue';
import 'floating-vue/dist/style.css';
import App from './App.vue';

import './assets/style/app.scss';

const app = createApp(App);

// Plugins
app.use(router);
app.use(i18n);
app.use(VeeValidatePlugin);
app.use(toast);
app.use(store);

// Directives
app.directive('tooltip', VTooltip);

// Mixins
app.mixin(helperMixin);

app.mount('#app');
